import { render, staticRenderFns } from "./rich_viewer.vue?vue&type=template&id=53bf6ba9&vue3"
import script from "./rich_viewer.vue?vue&type=script&lang=js&vue3"
export * from "./rich_viewer.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports